let isPullOrderPending = false;
let pullOrderTimeout = null;
let currentOrderRequest = null;
let sessionStartingToast = null;
let sessionReadyToast = null;
let isVerifone = false;
let isSessionStarted = false;
let accumulatedPrinted = {
  order_ids: new Set(),
  order_product_ids: new Set(),
  product_table_ids: new Set()
};

$(document).ready(function () {
  isVerifone = $('body').attr('is_verifone') === '1';
  if (window.ReactNativeWebView) {
    $.ajax({
      url: "/api/v1/check-login",
      method: "GET",
      dataType: "json",
    })
      .done(function (data) {
        if (data && data.isLoggedIn) {
          getOrderToPrint().always(() => {
            isPullOrderPending = false;
          });

          passVerifoneDataToWebView({
            action: 'verifone',
            data: {
                action: 'initialize'
            }
          })
        }
      })
      .fail(function (xhr, status, error) {
        console.error("Error fetching login status:", error);
      });

    function handleOrderPull(printedIds) {
      if (printedIds) {
        printedIds.order_ids?.forEach(id => accumulatedPrinted.order_ids.add(id));
        printedIds.order_product_ids?.forEach(id => accumulatedPrinted.order_product_ids.add(id));
        printedIds.product_table_ids?.forEach(id => accumulatedPrinted.product_table_ids.add(id));
      }

      if (isPullOrderPending) {
        cancelOrderPull();
      }

      if (pullOrderTimeout) {
        clearTimeout(pullOrderTimeout);
      }

      isPullOrderPending = true;

      pullOrderTimeout = setTimeout(() => {
        const toSend = {
          order_ids: Array.from(accumulatedPrinted.order_ids),
          order_product_ids: Array.from(accumulatedPrinted.order_product_ids),
          product_table_ids: Array.from(accumulatedPrinted.product_table_ids)
        };

        currentOrderRequest = getOrderToPrint(toSend);
        currentOrderRequest
        .done(() => {
            accumulatedPrinted.order_ids.clear();
            accumulatedPrinted.order_product_ids.clear();
            accumulatedPrinted.product_table_ids.clear();
        })
        .always(() => {
          isPullOrderPending = false;
          pullOrderTimeout = null;
          currentOrderRequest = null;
        });
      }, 7000);
    }

    document.addEventListener("message", function (event) {
      const data = JSON.parse(event.data);
      switch (data.action) {
        case "pull_order":
        case "app_state_active":
            handleOrderPull(data.data);
            break;
        case "web_print_completed":
            const deviceId = data.deviceId;
            const { order_ids: orderIds } = data.data;
            const socketData = {
                type: "web_print_completed",
                deviceId,
                orderIds,
            };
            window.globalSocket.send(JSON.stringify(socketData));
            break;
        case "speech_search":
            appendProductSuggestions(event.data);
            break;
        case "printer_discovery":
            const location_id = $(this).data("location-id");
            savedFoundPrinters(event.data, location_id);
            break;
        case "initialized_sdk":
            break;
        case "verifone_state":{
            const { data: result } = data;
            if (result) {
                if (result.state === "NOT_LOGGED_IN") {
                    let p = $("body").attr("p");
                    let posType = $("body").attr("pos_type");

                    if (p === "events" && !!posType) {
                        showToast({
                            type: "error",
                            message: "Verifone pålogging mislyktes. Vennligst prøv igjen eller kontakt oss.",
                            autoHide: false,
                            dismissOnSwipe: true,
                            button: { text: 'Prøv på nytt', onClick: () => {
                                passVerifoneDataToWebView({
                                    action: 'verifone',
                                    data: {
                                        action: 'initialize'
                                    }
                                })
                                $(".toaster").remove();
                            }}
                        });
                    }
                } else if (result.state === "CONNECTION_LOST") {
                    isSessionStarted = false;
                    if ($("body").attr("is-verifone-session-started") && $("body").attr("is-verifone-session-started") === '1') {
                        $("body").attr("is-verifone-session-started", '0');
                    }

                    if ($("#payment-split-modal").length) {
                        $(".payment-split-input[data-payment-method='payment_verifone_terminal']").prop("disabled", true);
                        $(".order-payment-split[data-payment-method='payment_verifone_terminal']").prop("disabled", true);
                    }
                    
                    showToast({
                        type: "error",
                        message: "Terminalforbindelsen er brutt. Prøv på nytt eller kontakt oss.",
                        position: "top-right",
                        autoHide: false,
                        dismissOnSwipe: true,
                        button: { text: 'Koble til igjen', onClick: () => {
                            passVerifoneDataToWebView({
                                action: 'verifone',
                                data: {
                                    action: 'initialize'
                                }
                            })
                            $(".toaster").remove();
                        }}
                    });
                } else if (result.state === "LOGGED_IN") {
                    let p = $("body").attr("p");
                    let posType = $("body").attr("pos_type");

                    if (p === "events" && !!posType) {
                        sessionReadyToast = null;
                        isSessionStarted = false;
                        if (!sessionStartingToast) {
                            sessionStartingToast = showToast({
                                message: "Vent litt!",
                                position: "bottom-center",
                                autoHide: false,
                                dismissOnSwipe: true,
                            })
                        }

                    }
                    passVerifoneDataToWebView({
                        action: "verifone",
                        data: {
                            action: "start_session"
                        }
                    })
                } else if (result.state === "SESSION_OPEN") {
                    if (sessionStartingToast) {
                        sessionStartingToast?.close();
                        sessionStartingToast = null;
                        isSessionStarted = true;

                        if (!$("body").attr("is-verifone-session-started") || $("body").attr("is-verifone-session-started") === '0') {
                            $("body").attr("is-verifone-session-started", '1');
                        }

                        if ($("#payment-split-modal").length) {
                            $(".payment-split-input[data-payment-method='payment_verifone_terminal']").prop("disabled", false);
                            $(".order-payment-split[data-payment-method='payment_verifone_terminal']").prop("disabled", false);
                        }

                        if (!sessionReadyToast) {
                            sessionReadyToast = showToast({
                                message: "Klar for transaksjoner",
                                position: "bottom-center",
                                autoHide: true,
                                duration: 3000,
                                dismissOnSwipe: true,
                            })
                        }
                    }

                    $(".quick-order-button[data-payment-method='payment_verifone_terminal']").prop("disabled", false);
                } else if (result.state === "SESSION_START_FAILED") {
                    isSessionStarted = false;

                    if ($("body").attr("is-verifone-session-started") && $("body").attr("is-verifone-session-started") === '1') {
                        $("body").attr("is-verifone-session-started", '0');
                    }

                    if ($("#payment-split-modal").length) {
                        $(".payment-split-input[data-payment-method='payment_verifone_terminal']").prop("disabled", true);
                        $(".order-payment-split[data-payment-method='payment_verifone_terminal']").prop("disabled", true);
                    }
                    
                    showToast({
                        type: "error",
                        message: "Verifone terminal økt start mislyktes. Vennligst prøv igjen eller kontakt oss.",
                        autoHide: false,
                        dismissOnSwipe: true,
                        button: { text: 'Prøv på nytt', onClick: () => {
                            passVerifoneDataToWebView({
                                action: 'verifone',
                                data: {
                                    action: 'initialize'
                                }
                            })
                            $(".toaster").remove();
                        }}
                    });
                }
            }
            break;
        }
        case "payment_completed": {
            const { data: result } = data
            if (result.authResult === "AUTHORIZED") {
                const [orderId, orderPaymentSplitId] = String(result.orderId).split('-');
                $.ajax({
                    url: "/api/v1/private/order/complete-verifone-order",
                    method: "POST",
                    dataType: "json",
                    data: {
                        order_id: orderId,
                        card_type: result.cardType || "",
                        order_payment_split_id: orderPaymentSplitId || null,
                    },
                })
                .done(function (response) {
                    if (response.success) {
                        if ($("#paymentProcessModal").hasClass("show")) {
                            $("#paymentProcessModal").modal("hide");
                        }

                        if (orderPaymentSplitId && response.success) {
                            if (!response.item_count && !response.total_amount) {
                                passVerifoneDataToWebView({
                                    action: "verifone",
                                    data: {
                                        action: "start_session"
                                    }
                                })
                            }
                            const splitInput = $(`.payment-split-input[data-payment-method='payment_verifone_terminal']`);
                            const splitButton = $(`.order-payment-split[data-payment-method='payment_verifone_terminal']`);
                            splitButton.find("div.loader").remove();
                            splitButton.attr("disabled", false);
                            splitButton.text(splitButton.attr("data-original-text"));
                            const paidAmount = parseFloat(splitInput.val());
                            splitInput.val("");

                            let totalAmount = parseFloat(
                                splitInput.attr("data-max-allowed")
                            );
                            const remainingAmout = parseFloat(
                                $("#total-amount").attr("data-total-amount")
                            );
                            const totalPaid = totalAmount - remainingAmout + paidAmount;
                            if (totalPaid > 0) {
                                const remainingValue = (totalAmount * 100 - totalPaid * 100) / 100;
                                $("#total-amount").text(
                                `Gjenværende totalt: ${formattedPriceToShow(remainingValue)}`
                                );
                                $("#total-amount").attr("data-total-amount", remainingValue);

                                $("#payment-split-input").attr("data-max-allowed", remainingValue);
                            }
                        }
                        
                        if (response.item_count && response.total_amount) {
                            sessionReadyToast = null;
                            isSessionStarted = false;

                            if ($("#payment-split-modal").length) {
                                $("#payment-split-modal").modal("hide");
                            }
                            
                            showPreviousSaleBar(response.item_count, response.total_amount);
                            passVerifoneDataToWebView({
                                action: "verifone",
                                data: {
                                    action: "start_session"
                                }
                            })

                            emptyAllCart();
                            closePanel();
                        }
                    }
                })
            } else if (result.authResult === "DECLINED") {
                $("#paymentProcessSpinner").addClass("d-none");
                $("#paymentProcessError").removeClass("d-none");
                const declinedMessage = $("#paymentStatus").data("declined-message") || "Payment Declined";
                $("#paymentStatus").text(declinedMessage);
                $("#retryPaymentButton").removeClass("d-none");

                sessionReadyToast = null;
                isSessionStarted = false;
                passVerifoneDataToWebView({
                    action: "verifone",
                    data: {
                        action: "start_session"
                    }
                })

                const splitButton = $(`.order-payment-split[data-payment-method='payment_verifone_terminal']`);
                $("#payment-split-input").attr("disabled", false);
                splitButton.find("div.loader").remove();
                splitButton.attr("disabled", false);
                splitButton.text(splitButton.attr("data-original-text"));

                paymentData = result.paymentData;
            } else if (result.authResult === "USER_CANCELLED") {
                $("#paymentProcessSpinner").addClass("d-none");
                $("#paymentProcessError").removeClass("d-none");
                const userCancelledMessage = $("#paymentStatus").data("user-cancelled-message") || "Payment Cancelled by User";
                $("#paymentStatus").text(userCancelledMessage);
                $("#retryPaymentButton").removeClass("d-none");

                sessionReadyToast = null;
                isSessionStarted = false;
                passVerifoneDataToWebView({
                    action: "verifone",
                    data: {
                        action: "start_session"
                    }
                })

                const splitButton = $(`.order-payment-split[data-payment-method='payment_verifone_terminal']`);
                $("#payment-split-input").attr("disabled", false);
                splitButton.find("div.loader").remove();
                splitButton.attr("disabled", false);
                splitButton.text(splitButton.attr("data-original-text"));

                paymentData = result.paymentData;
            } else {
                $("#paymentProcessSpinner").addClass("d-none");
                $("#paymentProcessError").removeClass("d-none");
                const userCancelledMessage = $("#paymentStatus").data("user-cancelled-message") || "Payment Cancelled by User";
                $("#paymentStatus").text(userCancelledMessage);
                $("#retryPaymentButton").removeClass("d-none");

                sessionReadyToast = null;
                isSessionStarted = false;
                passVerifoneDataToWebView({
                    action: "verifone",
                    data: {
                        action: "start_session"
                    }
                })

                const splitButton = $(`.order-payment-split[data-payment-method='payment_verifone_terminal']`);
                $("#payment-split-input").attr("disabled", false);
                splitButton.find("div.loader").remove();
                splitButton.attr("disabled", false);
                splitButton.text(splitButton.attr("data-original-text"));

                paymentData = result.paymentData;
            }
            break;
        }
        case "device_info": {
            const { data: result } = data;
            if (result?.isVerifone && result) {
                $(".device-information-section").removeClass("d-none");
                var deviceData = result;

                $('#appVersion').text(deviceData.applicationVersion || 'N/A');
                $('#paymentAppName').text(deviceData.paymentAppName || 'N/A');
                $('#paymentAppVersion').text(deviceData.paymentAppVersion || 'N/A');
                $('#serialNumber').text(deviceData.serialNumber || 'N/A');
            }
        }
      }
    });

    window.addEventListener("message", function (event) {
      const data = JSON.parse(event.data);
      switch (data.action) {
        case "pull_order":
        case "app_state_active":
            handleOrderPull(data.data);
            break;
        case "web_print_completed":
            const deviceId = data.deviceId;
            const { order_ids: orderIds } = data.data;
            const socketData = {
                type: "web_print_completed",
                deviceId,
                orderIds,
            };
            window.globalSocket.send(JSON.stringify(socketData));
            break;
        case "speech_search":
            appendProductSuggestions(event.data);
            break;
        case "printer_discovery":
            const location_id = $(this).data("location-id");
            savedFoundPrinters(event.data, location_id);
            break;
        case "initialized_sdk":
            break;
        case "verifone_state":{
            const { data: result } = data;
            if (result) {
                if (result.state === "NOT_LOGGED_IN") {
                    let p = $("body").attr("p");
                    let posType = $("body").attr("pos_type");

                    if (p === "events" && !!posType) {
                        showToast({
                            type: "error",
                            message: "Verifone pålogging mislyktes. Vennligst prøv igjen eller kontakt oss.",
                            autoHide: false,
                            dismissOnSwipe: true,
                            button: { text: 'Prøv på nytt', onClick: () => {
                                passVerifoneDataToWebView({
                                    action: 'verifone',
                                    data: {
                                        action: 'initialize'
                                    }
                                })
                                $(".toaster").remove();
                            }}
                        });
                    }
                } else if (result.state === "CONNECTION_LOST") {
                    showToast({
                        type: "error",
                        message: "Terminalforbindelsen er brutt. Prøv på nytt eller kontakt oss.",
                        autoHide: false,
                        dismissOnSwipe: true,
                        button: { text: 'Koble til igjen', onClick: () => {
                            passVerifoneDataToWebView({
                                action: 'verifone',
                                data: {
                                    action: 'initialize'
                                }
                            })
                            $(".toaster").remove();
                        }}
                    });
                } else if (result.state === "LOGGED_IN") {
                    let p = $("body").attr("p");
                    let posType = $("body").attr("pos_type");

                    if (p === "events" && !!posType) {
                        sessionReadyToast = null;
                        if (!sessionStartingToast) {
                            sessionStartingToast = showToast({
                                message: "Vent litt!",
                                position: "bottom-center",
                                autoHide: false,
                                dismissOnSwipe: true,
                            })
                        }

                        passVerifoneDataToWebView({
                            action: "verifone",
                            data: {
                                action: "start_session"
                            }
                        })
                    }
                } else if (result.state === "SESSION_OPEN") {
                    if (sessionStartingToast) {
                        sessionStartingToast?.close();
                        sessionStartingToast = null;
                        if (!sessionReadyToast) {
                            sessionReadyToast = showToast({
                                message: "Klar for transaksjoner",
                                position: "bottom-center",
                                autoHide: true,
                                duration: 3000,
                                dismissOnSwipe: true,
                            })
                        }
                    }

                    $(".quick-order-button[data-payment-method='payment_verifone_terminal']").prop("disabled", false);
                } else if (result.state === "SESSION_START_FAILED") {
                    showToast({
                        type: "error",
                        message: "Verifone terminal økt start mislyktes. Vennligst prøv igjen eller kontakt oss.",
                        autoHide: false,
                        dismissOnSwipe: true,
                        button: { text: 'Prøv på nytt', onClick: () => {
                            passVerifoneDataToWebView({
                                action: 'verifone',
                                data: {
                                    action: 'initialize'
                                }
                            })
                            $(".toaster").remove();
                        }}
                    });
                }
            }
            break;
        }
        case "payment_completed": {
            const { data: result } = data
            if (result.authResult === "AUTHORIZED") {
                $.ajax({
                    url: "/api/v1/private/order/complete-verifone-order",
                    method: "POST",
                    dataType: "json",
                    data: {
                        order_id: result.orderId,
                        card_type: result.cardType || "",
                    },
                })
                .done(function (response) {
                    if (response.success) {
                        if ($("#paymentProcessModal").hasClass("show")) {
                            $("#paymentProcessModal").modal("hide");
                        }

                        if (response.item_count && response.total_amount) {
                            sessionReadyToast = null;
                            showPreviousSaleBar(response.item_count, response.total_amount);
                            passVerifoneDataToWebView({
                                action: "verifone",
                                data: {
                                    action: "start_session"
                                }
                            })
                        }
                        emptyAllCart();
                        closePanel();
                    }
                })
            } else if (result.authResult === "DECLINED") {
                $("#paymentProcessSpinner").addClass("d-none");
                $("#paymentProcessError").removeClass("d-none");
                const declinedMessage = $("#paymentStatus").data("declined-message") || "Payment Declined";
                $("#paymentStatus").text(declinedMessage);
                $("#retryPaymentButton").removeClass("d-none");

                sessionReadyToast = null;

                passVerifoneDataToWebView({
                    action: "verifone",
                    data: {
                        action: "start_session"
                    }
                })
                paymentData = result.paymentData;
            } else if (result.authResult === "USER_CANCELLED") {
                $("#paymentProcessSpinner").addClass("d-none");
                $("#paymentProcessError").removeClass("d-none");
                const userCancelledMessage = $("#paymentStatus").data("user-cancelled-message") || "Payment Cancelled by User";
                $("#paymentStatus").text(userCancelledMessage);
                $("#retryPaymentButton").removeClass("d-none");

                sessionReadyToast = null;

                passVerifoneDataToWebView({
                    action: "verifone",
                    data: {
                        action: "start_session"
                    }
                })
                paymentData = result.paymentData;
            }
            break;
        }
        case "device_info": {
            const { data: result } = data;
            if (result?.isVerifone && result) {
                $(".device-information-section").removeClass("d-none");
                var deviceData = result;

                $('#appVersion').text(deviceData.applicationVersion || 'N/A');
                $('#paymentAppName').text(deviceData.paymentAppName || 'N/A');
                $('#paymentAppVersion').text(deviceData.paymentAppVersion || 'N/A');
                $('#serialNumber').text(deviceData.serialNumber || 'N/A');
            }
        }
      }
    });
  }
});

function cancelOrderPull() {
  if (currentOrderRequest) {
    currentOrderRequest.abort();
    currentOrderRequest = null;
  }

  if (pullOrderTimeout) {
    clearTimeout(pullOrderTimeout);
    pullOrderTimeout = null;
  }

  isPullOrderPending = false;
}